import { render, staticRenderFns } from "./UnsuccessView.vue?vue&type=template&id=bc718c3a&scoped=true"
import script from "./UnsuccessView.vue?vue&type=script&lang=js"
export * from "./UnsuccessView.vue?vue&type=script&lang=js"
import style0 from "./UnsuccessView.vue?vue&type=style&index=0&id=bc718c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc718c3a",
  null
  
)

export default component.exports